'use client'
import { useEffect, useState } from 'react'
import { IconArrowNarrowUp } from '@tabler/icons-react'
import clsx from 'clsx'

import IconButton, { type IconButtonProps } from '../IconButton/IconButton'

import styles from './BackToTopButton.module.scss'

const GoToTopButton = ({
  className,
  size = 'medium',
  variant = 'green',
  ...props
}: IconButtonProps) => (
  <IconButton
    size={size}
    variant={variant}
    className={clsx(styles.goToTop, className)}
    {...props}
  />
)

type BackToTopButtonProps = {
  target: string
}

const BackToTopButton = ({ target }: BackToTopButtonProps) => {
  const [isVisible, setIsVisible] = useState(false)

  const handleScroll = () => {
    const scrollTop = window.scrollY

    if (scrollTop > 400) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const scrollToTop = () => {
    const title = document.querySelector(target)

    title?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    isVisible && (
      <GoToTopButton
        variant='green'
        onClick={scrollToTop}
        aria-label='Powrót na górę strony'
      >
        <IconArrowNarrowUp />
      </GoToTopButton>
    )
  )
}

export default BackToTopButton
